import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as React from 'react';
import {render, DefaultProviders, ModalProvider} from '@mc/react-app-v4';
import App from './App';
import {Helmet} from 'react-helmet';
import {ThemeContextProvider} from '@mc/react-theme-context';
import {FinalTableDataProvider, RowsDataProvider} from '@mc/ui-v4';
import './index.scss';
import {MapioContextWrapper} from './components/wrappers/MapioContextWrapper';
import './setupGlobal';
render(
    <DefaultProviders queryClientConfig={{defaultOptions: {queries: {retry: false, refetchOnWindowFocus: false}}}}>
        <MapioContextWrapper>
            <ModalProvider />
            <Helmet>
                <title>Mapiio</title>
            </Helmet>
            <ThemeContextProvider theme={{ns: 'ui-default'}}>
                <RowsDataProvider>
                    <FinalTableDataProvider>
                        <App />
                    </FinalTableDataProvider>
                </RowsDataProvider>
            </ThemeContextProvider>
        </MapioContextWrapper>
    </DefaultProviders>,
);
